<script setup>
import i18n from "@/i18n";
import { useDeviceState } from "@/stores/deviceState";
import ListContainer from "@module-system/ViewModule/ListContainer.vue";
import { onMounted, ref } from "vue";
import { setUrlParamWithWatch } from "@/utils";
const cameraDeviceList = ref([]);
const micDeviceList = ref([]);
const currentTab = ref("deviceSettings");

setUrlParamWithWatch("change-devices-tab", currentTab, undefined, undefined, undefined, true);

const deviceState = useDeviceState();

// emit when device changed
const emit = defineEmits(["deviceChanged"]);

onMounted(async () => {
  await deviceState.ready;
  deviceState.cameraPermission.addEventListener("change", () => {
    getDevices();
  });
  deviceState.microphonePermission.addEventListener("change", () => {
    getDevices();
  });
  await deviceState.checkPermissions();
  getDevices();
});

async function getDevices() {
  if (!deviceState.cameraPermission) {
    return;
  }

  if (!deviceState.microphonePermission) {
    return;
  }

  // check if granted
  if (deviceState.cameraPermission?.state !== "granted" && deviceState.cameraPermission?.state !== "prompt") {
    console.log("camera permission not granted yet, cannot get devices:", deviceState.cameraPermission?.state);
    return;
  }

  if (deviceState.microphonePermission?.state === "denied") {
    console.log("microphone permission not granted yet, cannot get devices:", deviceState.microphonePermission?.state);
    return;
  }

  let devices = await navigator.mediaDevices.enumerateDevices();
  const cameras = devices.filter((device) => device.kind == "videoinput");
  const mics = devices.filter((device) => device.kind == "audioinput");

  cameraDeviceList.value = [
    {
      value: "",
      label: i18n.global.t("Default"),
    },
    ...cameras.map((camera) => {
      return {
        value: camera.deviceId,
        label: camera.label,
      };
    }),
  ];

  micDeviceList.value = [
    {
      value: "",
      label: i18n.global.t("Default"),
    },
    ...mics.map((mic) => {
      return {
        value: mic.deviceId,
        label: mic.label,
      };
    }),
  ];
}

function clearSelections() {
  setCameraId(null);
  setMicrophoneId(null);
}

async function setCameraId(e) {
  await deviceState.setCameraId(e);
  emit("deviceChanged");
  console.log("setCameraId", e);
}

async function setMicrophoneId(e) {
  await deviceState.setMicrophoneId(e);
  emit("deviceChanged");
  console.log("setMicrophoneId", e);
}
</script>
<template>
  <v-container style="max-height: 100%; overflow-y: auto">
    <v-tabs v-model="currentTab">
      <v-tab value="deviceSettings">{{ $t("DeviceSettings") }}</v-tab>
      <ListContainer :section-type="'CameraSettingsTabs'"> </ListContainer>
    </v-tabs>
    <v-window v-model="currentTab">
      <v-window-item value="deviceSettings">
        <v-select
          :model-value="deviceState.cameraId"
          :items="cameraDeviceList"
          item-title="label"
          :label="$t('SelectCam')"
          @update:model-value="setCameraId"></v-select>
        <v-select
          :model-value="deviceState.microphoneId"
          :items="micDeviceList"
          item-title="label"
          :label="$t('SelectMic')"
          @update:model-value="setMicrophoneId"></v-select>
        <v-row>
          <v-col cols="6">
            <v-btn block class="mt-4" @click="getDevices" color="primary">
              {{ $t("RefreshDeviceList") }}
            </v-btn>
          </v-col>
          <v-col cols="6" >
            <v-btn block class="mt-4" @click="clearSelections" color="primary">
              {{ $t("ClearDeviceSelections") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-window-item>

      <ListContainer :section-type="'CameraSettingsWindows'"> </ListContainer>
    </v-window>
  </v-container>
</template>
